import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import { ValuePerMonthPerYearTotal } from './ValuePerMonthPerYearTotal';
import { ValuePerYearTotal } from './ValuePerYearTotal';

const Value = () => {
    const { isLoading, data } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ValuePerYearTotal />
                <ValuePerMonthPerYearTotal />
            </div>
        </>
    );
};

export default Value;
